import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import VisitsChart from "./charts/VisitsChart";

const VisitsContainer = styled(Box)`
    background: white; padding: 20px; border-radius: 5px;
    display: flex; flex-direction: column; gap: 20px;
`;

const Visits = ({ isLoading, weeklyData }: any) => {

    return (
        <VisitsContainer>
            <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>Weekly Visits</Typography>
            <Grid container spacing={2}>
                <Grid item xs={9}>
                    <VisitsChart data={weeklyData?.weeklyData} />
                </Grid>
                <Grid item xs={3}>
                    <GraphInfoSec data={weeklyData} />
                </Grid>

            </Grid>

        </VisitsContainer>
    );
}

const GraphInfoSec = ({ data }: any) => {

    return (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start" }}>
            <Typography variant="h3" component="p" sx={{ color: "rgba(151, 71, 255, 1)" }}>{data?.totalWeekVisit}</Typography>
            <Typography style={{ fontSize: '15px' }}>Total Visits Last week</Typography>
        </Box>
    )
}


export default Visits;